var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoVideo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4301 15.3828H5.56988C2.13976 15.3828 1 13.637 1 11.8828V4.88281C1 2.25573 2.13976 1.38281 5.56988 1.38281H12.4301C15.8602 1.38281 17 2.25573 17 4.88281V11.8828C17 14.5099 15.8494 15.3828 12.4301 15.3828Z",
    stroke: "#005386",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8926 12.9664L17.25 11.2144V5.54502L19.8926 3.793C21.1854 2.93945 22.25 3.46056 22.25 4.96101V11.8074C22.25 13.3078 21.1854 13.8289 19.8926 12.9664Z",
    stroke: "#005386",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.38281C13.3284 7.38281 14 6.71124 14 5.88281C14 5.05439 13.3284 4.38281 12.5 4.38281C11.6716 4.38281 11 5.05439 11 5.88281C11 6.71124 11.6716 7.38281 12.5 7.38281Z",
    stroke: "#005386",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoVideo);
export default __webpack_public_path__ + "static/media/info_video.d67dd64feb5d1df048a0b7892c873cf7.svg";
export { ForwardRef as ReactComponent };